import { css } from '@emotion/react';

import { mqMin } from '../breakpoints';
import type { EmotionTheme } from '../../types/emotion-theme';

const blogStyles = (theme: EmotionTheme) =>
  css({
    strong: {
      fontWeight: theme.fontWeights.stronger,
    },
    h2: {
      scrollBehavior: 'smooth',
      scrollSnapAlign: 'start',
      scrollSnapStop: 'normal',
      scrollMarginTop: '70px',
    },
    '> ul, > ol': {
      margin: theme.space[4],
      li: {
        fontSize: theme.fontSizes[4],
        marginBottom: theme.space[2],
      },
    },
    iframe: {
      margin: `${theme.space[6]}px 0`,
      width: '100%',
      '&[src*="embeddedchart"]': {
        minHeight: '320px',
        [mqMin.tabletSmall]: {
          minHeight: '480px',
        },
      },
      '&[src*="wistia"]': {
        margin: '0',
        width: '100%',
        height: '100%',
      },
    },
    pre: {
      whiteSpace: 'pre-wrap',
    },
    '.wistia_responsive_padding': {
      margin: `${theme.space[6]}px auto`,
      padding: '56.25% 0 0 0',
      position: 'relative',
    },
    '.wistia_responsive_wrapper': {
      height: '100%',
      left: '0',
      position: 'absolute',
      top: '0',
      width: '100%',
    },
  });

export default blogStyles;
